// extracted by mini-css-extract-plugin
export default {"envelope-preview":"styles_envelope-preview__KK8cV","envelopeSelection":"styles_envelopeSelection__1l9VK"};